module.exports = __webpack_public_path__ + "img/1993_uk.f7ae3a41.svg";